var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPh = function SvgPh(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21796_21061",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "rotate(-180 10 10)",
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21796_21061)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "rotate(-180 10 10)",
    fill: "#1034AC"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 10,
    height: 20,
    transform: "rotate(-90 0 20)",
    fill: "#BF2842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.2407L-0.25 1.78897L-0.25 18.6925L12.5 10.2407Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.45625 11.5043L3.35625 10.8293L3.1875 10.4918L1.89375 10.548L1.5 10.098L1.89375 9.4793L3.1875 9.64805L3.35625 9.31055L2.34375 8.3543L2.45625 7.73555H3.1875L3.975 8.6918L4.3125 8.5793L4.2 7.2293L4.81875 6.7793L5.325 7.3418L5.2125 8.5793L5.55 8.6918L6.3375 7.73555H7.06875V8.4668L6.05625 9.31055L6.225 9.64805L7.575 9.53555L7.96875 10.098L7.4625 10.6605L6.225 10.4918L6.05625 10.8855L7.06875 11.6168V12.4605H6.225L5.49375 11.3918L5.1 11.5043L5.2125 12.7418L4.65 13.3043L4.14375 12.7418L4.3125 11.5043L3.8625 11.3918L3.075 12.2918H2.45625V11.5043Z",
    fill: "#F0CC5A"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPh);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ph.43ebf8034ff3e205ac86763fe7a03dd3.svg";